import { render, staticRenderFns } from "./DragTableAlocated.vue?vue&type=template&id=f9c78568&scoped=true"
import script from "./DragTableAlocated.vue?vue&type=script&lang=js"
export * from "./DragTableAlocated.vue?vue&type=script&lang=js"
import style0 from "./DragTableAlocated.vue?vue&type=style&index=0&id=f9c78568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c78568",
  null
  
)

export default component.exports